import React from 'react';
import PropTypes from 'prop-types';
import './Loader.css';

function Loader({ style, className, centered = false }) {
  const wrapperClass = [
    'loader-container',
    centered ? 'loader-centered' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div style={style} className={wrapperClass}>
      <img src="/loadingGif.gif" alt="Loading..." className="loader-gif" />
    </div>
  );
}

Loader.propTypes = {
  style: PropTypes.object,
  className: PropTypes.string,
  centered: PropTypes.bool,
};

export default Loader;
